import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api, userTimezone } from "@/lib/api";

export const TRIAL_KEY = "rs_trial";

export const getTrial = () => {
  try { return JSON.parse(localStorage.getItem(TRIAL_KEY)); } catch { return null; }
};

let claiming = false;

// Saves the pre-signup analysis into the new account's journal once (no extra AI call).
export function useClaimTrial(user) {
  const qc = useQueryClient();
  useEffect(() => {
    const t = getTrial();
    if (!user?.onboarded || !t?.trial_id || claiming) return;
    claiming = true;
    api.post("/try/claim", { trial_id: t.trial_id, timezone: userTimezone() })
      .then(() => {
        localStorage.removeItem(TRIAL_KEY);
        qc.invalidateQueries();
        toast.success("Your first session is saved", { description: "The analysis you tried is now in your journal." });
      })
      .catch((err) => {
        if (err?.response?.status === 404) localStorage.removeItem(TRIAL_KEY);
      })
      .finally(() => { claiming = false; });
  }, [user?.onboarded, user?.id, qc]);
}
